import Swiper, { Autoplay } from 'swiper';

const SccTerminalScrollbar = {
    init() {
        if ($('.sccTerminalScrollbarSwiper').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.sccTerminalScrollbarSwiper')[0], {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 24,
            speed: 4000,
            // // loopedSlides: 10,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
              allowTouchMove: false,

            // Optional: disable mouse dragging as well
            simulateTouch: false,

            modules: [Autoplay],
        });
    },
}

export default SccTerminalScrollbar;



// WEBPACK FOOTER //
// ./scripts/modules/components/_scc-terminal-scrollbar.js